"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireWildcard(require("react"));

var HomeIcon = function HomeIcon(props) {
  return _react["default"].createElement("svg", {
    width: "30px",
    height: "30px",
    viewBox: "0 0 32 32",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": "home-title",
    role: "img"
  }, _react["default"].createElement("title", {
    id: "home-title"
  }, "Home"), _react["default"].createElement("polyline", {
    className: "cls-1 hvr-icon-stroke",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2px",
    points: "14.98 26 23.98 26 23.98 4 21 4 21 8 16 3 5 14"
  }), _react["default"].createElement("polyline", {
    className: "cls-1 hvr-icon-stroke",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2px",
    points: "8.98 26 7.98 26 7.98 11"
  }), _react["default"].createElement("rect", {
    className: "cls-1 hvr-icon-stroke",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2px",
    x: "15.98",
    y: "14",
    width: "4",
    height: "4"
  }), _react["default"].createElement("circle", {
    className: "cls-2 hvr-icon-fill",
    cx: "11.98",
    cy: "26",
    r: "1.25",
    fill: "#fff"
  }), _react["default"].createElement("line", {
    className: "cls-1 hvr-icon-stroke",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2px",
    x1: "19.5",
    y1: "6.5",
    x2: "27",
    y2: "14"
  }));
};

var _default = HomeIcon;
exports["default"] = _default;